import { queryOptions } from '@tanstack/react-query'

import { tokenMgmtFetcher } from '@/libs/fetcher/presets'

export interface TokenizedStockItem {
  id: number
  name: string
  symbol: string
  slug: string
  icon: string
  status: string
  source_id: number
  price_engine_enabled: boolean
  rwa_token_id: number
  stock_symbol: string
  trading_hours: string
  visibility: string
  is_fractional: boolean
}

export const fetchTokenizedStocks = (): Promise<TokenizedStockItem[]> =>
  tokenMgmtFetcher<TokenizedStockItem[]>('/v1/tokenized-stock/all-tokens')

export const tokenizedStocksQueryOptions = () =>
  queryOptions({
    queryKey: ['tokenizedStocks'],
    queryFn: fetchTokenizedStocks,
  })
